import React from 'react';
import { API_ROOT } from '../../../../baseUrls';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getMindfile } from './../../../../state/actions/getDataActions';
import { removeFriend } from './../../../../state/actions/updateDataActions';
import { withStyles } from '@material-ui/core/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Loader from '../../../organisms/loader/Loader';
import {formatLocation, formatStyles} from "../../../../helpers/FormatUtils";

const styles = {
  ...formatStyles,
  iconTextBlock: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  iconText: {
    marginLeft: 8,
  },
  removeIcon: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  tableContainer: {
    overflow: 'scroll',
  },
};

class BrowseFriends extends React.Component {
  state = {
    isDialogOpen: false,
    selectedRemoveFriend: null,
    isLoading: false,
  }

  changeMindfile(mid) {
    return () => {
      this.setState({isLoading: true});
      this.props.getMindfile(mid, () => {
        this.props.history.push('/explore');
      });
    }
  }

  openDialog(friend) {
    return () => {
      this.setState({
        selectedRemoveFriend: friend,
        isDialogOpen: true
      })
    }
  }

  removeFriend() {
    const user = this.state.selectedRemoveFriend
    if (user) {
      fetch(`${ API_ROOT }/mindfiles/${this.props.mindfile.id}/unfriend/${user.id}`, {
        method: 'GET',
        credentials: 'include',
      })
      .then((resp) => {
        resp.json().then((result) => {
          if (result[0].status === 'ok') {
            this.props.removeFriend(user)
          }
        })
        .catch((error) => {
          console.error(error)
        })
      })
      .catch((error) => {
        console.error(error)
      })
    }

    this.setState({isDialogOpen: false})
  }

  friendsTable(classes) {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Mindfile</TableCell>
            <TableCell>Location</TableCell>
            { this.props.isCurrentMindfileOwner ? <TableCell>Remove</TableCell> : null }
          </TableRow>
        </TableHead>
        <TableBody style={{backgroundColor: "#fff"}}>
          {this.props.friends.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          }).map(friend =>
              <TableRow hover tabIndex={ -1 } key={ friend.bot_name }>
                <TableCell>{ friend.name }</TableCell>
                <TableCell><Box className={ classes.iconTextBlock } onClick={ this.changeMindfile(friend.id).bind(this) }><VisibilityIcon /><span className={ classes.iconText }>View mindfile</span></Box></TableCell>
                <TableCell>{ formatLocation(friend.id, friend.location, classes, {hideCoords: true}) }</TableCell>
                { this.props.isCurrentMindfileOwner ? <TableCell><Box onClick={ this.openDialog(friend).bind(this) } className={ classes.removeIcon }><HighlightOffIcon /></Box></TableCell> : null }
              </TableRow>
          )}
        </TableBody>
      </Table>
    )
  }

  render() {
    const { classes } = this.props
    return (
      <Box>
        <h1>Browse Friends</h1>
        <Box className={ classes.tableContainer }>
          {this.state.isLoading ? <Loader /> : this.friendsTable(classes)}
        </Box>
        <Dialog onClose={() => {this.setState({isDialogOpen: false})}} open={ this.state.isDialogOpen }>
          <DialogTitle>Remove</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Remove { this.state.selectedRemoveFriend ? this.state.selectedRemoveFriend.name : '' } from your friend list?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={ this.removeFriend.bind(this) }>Yes</Button>
            <Button variant="contained" color="secondary" onClick={() => {this.setState({isDialogOpen: false})}}>Cancel</Button>
          </DialogActions>
        </Dialog>
      </Box>
    )
  }
}

const styledBrowseFriends = withStyles(styles)((withRouter(BrowseFriends)))

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
    friends: state.friends,
    isCurrentMindfileOwner: state.isCurrentMindfileOwner,
  }
}

const mapDispatchToProps = {
  getMindfile,
  removeFriend,
};

export default connect(mapStateToProps, mapDispatchToProps)(styledBrowseFriends)
